// extracted by mini-css-extract-plugin
export var addToCartButton = "_s0-b";
export var arrowButtonContainer = "_s0-9";
export var arrowButtonIcon = "_s0-a";
export var carouselArrowButton = "_s0-6";
export var carouselElementContainer = "_s0-1";
export var left = "_s0-7";
export var productDisplayCarouselContainer = "_s0-0";
export var productTileContainer = "_s0-2";
export var productTileImage = "_s0-4";
export var productTileImageContainer = "_s0-3";
export var productTileTitle = "_s0-5";
export var right = "_s0-8";
export var sliderOverflow = "_s0-c";